<!-- Mirrors the canonical single-delete confirm card (app.component.html): centered, red Material trash badge. -->
<div class="relative flex flex-col items-center" cesConfirmDialogA11y labelledBy="bulk-delete-title" describedBy="bulk-delete-desc">
  <button
    type="button"
    class="absolute right-0 top-0 inline-flex h-8 w-8 items-center justify-center rounded text-(color:--text-secondary) transition-colors hover:bg-(--surface-1) hover:text-(color:--p-text-color) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(color:--p-primary-color)"
    [attr.aria-label]="'common.buttons.close' | transloco"
    (click)="cancel()">
    <span class="material-symbols">close</span>
  </button>

  <div class="rounded-full bg-(--p-red-200) inline-flex justify-center items-center h-16 w-16 mb-(--space-4)">
    <span class="material-symbols text-2xl" style="color: var(--p-red-100)" aria-hidden="true">delete</span>
  </div>

  <span id="bulk-delete-title" class="font-semibold text-xl mb-(--space-2)">{{ title }}</span>
  <p id="bulk-delete-desc" class="text-center text-(color:--text-secondary) mb-(--space-2)">{{ messageKey | transloco: { count } }}</p>
  <p class="text-center text-sm text-(color:--text-secondary) mb-(--space-6)">{{
    'common.messages.actionIrreversible' | transloco
  }}</p>

  @if (rows.length) {
    <div class="w-full mb-(--space-6)">
      @if (toDeleteKey) {
        <h4 class="text-sm font-semibold text-(color:--text-primary) mb-(--space-2)">{{ toDeleteKey | transloco }}</h4>
      }
      <div class="bg-(--surface-1) rounded-(--radius-md) p-(--space-3) text-sm max-h-40 overflow-y-auto">
        @for (row of rows; track $index) {
          <div class="flex items-center gap-(--gap-normal) py-(--space-1)">
            <span class="material-symbols text-base shrink-0" style="color: var(--p-red-300)" aria-hidden="true">remove_circle</span>
            <span>{{ row.label }}</span>
            @if (row.detail) {
              <span class="text-(color:--text-secondary)">({{ row.detail }})</span>
            }
          </div>
        }
      </div>
    </div>
  }

  <ces-dialog-footer
    class="w-full"
    [destructiveSubmit]="true"
    [submitLabel]="'common.buttons.delete' | transloco"
    (onSubmit)="confirmDeletion()"
    (onCancel)="cancel()" />
</div>
